import phpClient from '../phpAPI_Config'

async function get(authState: any, path: string) {
  return await phpClient(authState)
    .get<any>('/json' + path)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

async function post(authState: any, path: string, payload: any) {
  return await phpClient(authState)
    .post<any>('/json' + path, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

const PhpAPI = {
  get,
  post,
}

export default PhpAPI
